//Styles
import myStyles from "../../../../styles/referrals/ReferralEntityList.module.css"

// Prime React
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Skeleton } from "primereact/skeleton"
import { Paginator } from "primereact/paginator"
import { Badge } from "primereact/badge"
import { Tooltip } from "primereact/tooltip"
import { Button } from "primereact/button"
import { displayLocalDateTimeFromIso } from "../../../../helpers/displayDates"

export default function ReferralEntitiesListTable({
  isLoading,
  partnerData,
  filters,
  isPartnerUser,
  currentUserRole,
  currentUserOrganizationIds,
  onSetFilters,
  onShowPartnerServices,
  onEditPartner,
  onPageChange,
}) {
  const NameBody = (rowData) => {
    const categoryCount = !!rowData?.referralTypes
      ? rowData.referralTypes.length
      : 0

    return (
      <div className={myStyles.partnerNameBody}>
        <Tooltip target=".categoryBadge" />
        <div className={myStyles.partnerNameField}>
          {rowData.referralEntity.name}
        </div>
        <span
          className="categoryBadge"
          data-pr-tooltip="Referral categories allocated to this partner"
          onClick={() => {
            onShowPartnerServices(
              rowData.referralEntity.name,
              rowData.referralTypes
            )
          }}
        >
          <Badge
            className={` ${myStyles.categoryBadge} `}
            value={`${categoryCount}`}
            severity={categoryCount > 0 ? "" : "warning"}
          />
        </span>
      </div>
    )
  }

  const CreatorStaffBody = (rowData) => {
    return (
      <>{!rowData.creatingUserName ? "Unknown" : rowData.creatingUserName}</>
    )
  }

  const CreatorOrganizationBody = (rowData) => {
    return (
      <>
        {!rowData.creatingOrganization
          ? "Unknown"
          : rowData.creatingOrganization}
      </>
    )
  }

  const actionBodyTemplate = (rowData) => {
    let canEdit =
      isPartnerUser ||
      currentUserRole === 1 ||
      (currentUserRole > 1 &&
        currentUserRole <= 6 &&
        currentUserOrganizationIds?.includes(
          rowData?.referralEntity?.creationOrganizationId || "No creation org"
        ))

    if (isLoading) {
      return null
    }

    return (
      <div style={{ width: "100%" }}>
        <Button
          type="button"
          className={`${myStyles.actionButton}`}
          onClick={() => {
            onEditPartner(rowData.referralEntity.id)
          }}
          disabled={isLoading}
        >
          {canEdit ? "Edit" : "View"}
        </Button>
      </div>
    )
  }

  const CreationDateBody = (rowData) => {
    const date = displayLocalDateTimeFromIso(
      rowData.referralEntity?.dateCreated
    )
    return <>{date}</>
  }

  return (
    <div className={myStyles.listContainer}>
      <DataTable
        value={isLoading ? Array.from({ length: 5 }) : partnerData?.result}
        resizableColumns
        columnResizeMode="fit"
        className={myStyles.listTable}
        sortField={
          ["creatingOrganization", "creatingUserName", "city", "zipcode"].some(
            (noPrefix) => noPrefix === filters.sortField
          )
            ? filters.sortField
            : `referralEntity.${filters.sortField}`
        }
        sortOrder={filters.sortAscending ? 1 : -1}
        onSort={(event) => {
          const field = event.sortField.replace("referralEntity.", "")
          const ascending = event.sortOrder === 1

          onSetFilters({
            ...filters,
            sortField: field,
            sortAscending: ascending,
            includeFilterListing: false,
          })
        }}
      >
        <Column
          field="referralEntity.name"
          header="Name"
          body={isLoading ? <Skeleton /> : NameBody}
          style={{ width: "25%" }}
          sortable
        />
        <Column
          field="referralEntity.entityStatus"
          header="Status"
          body={isLoading ? <Skeleton /> : null}
          sortable
        />
        <Column
          field="city"
          header="City"
          body={isLoading ? <Skeleton /> : null}
          sortable
        />
        <Column
          field="zipcode"
          header="Zip code"
          body={isLoading ? <Skeleton /> : null}
          sortable
        />
        <Column
          header="Creator"
          field="creatingUserName"
          body={isLoading ? <Skeleton /> : CreatorStaffBody}
          style={{ width: "150px" }}
          sortable
        />
        <Column
          header="Creator Organization"
          field="creatingOrganization"
          body={isLoading ? <Skeleton /> : CreatorOrganizationBody}
          style={{ width: "150px" }}
          sortable
        />
        <Column
          header="Creation date"
          field="referralEntity.dateCreated"
          body={isLoading ? <Skeleton /> : CreationDateBody}
          style={{ width: "150px" }}
          sortable
        />

        <Column
          header=""
          body={actionBodyTemplate}
          alignFrozen="right"
          frozen
          style={{ width: "100px" }}
          resizeable={false}
        />
      </DataTable>
      {!!partnerData && !isLoading ? (
        <Paginator
          first={partnerData.pageSize * (partnerData.pageNum - 1)}
          rows={partnerData.pageSize}
          totalRecords={partnerData.numTotal}
          onPageChange={onPageChange}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      ) : null}
    </div>
  )
}
